const KEY = "oge-nail-studio.requests.v1";
const THEME_KEY = "oge-nail-studio.theme";

export const requestsStore = {
  load() {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  },
  save(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch {
      /* ignore */
    }
  },
  clear() {
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  },
};

export const themeStore = {
  load() {
    try {
      return localStorage.getItem(THEME_KEY); // "light" | "dark" | null
    } catch {
      return null;
    }
  },
  save(t) {
    try {
      localStorage.setItem(THEME_KEY, t);
    } catch {
      /* ignore */
    }
  },
};
